import type { AccountantStatusTransactionsDetailEntity } from "../entities/AccountantStatusEntity";
import type {
  AccountantStatusMonthParams,
  AccountantStatusRepository,
} from "../repositories/AccountantStatusRepository";

export class GetAccountantStatusMonthDetailTransactionsUseCase {
  constructor(private readonly repository: AccountantStatusRepository) {}

  async execute(
    params: AccountantStatusMonthParams,
  ): Promise<AccountantStatusTransactionsDetailEntity> {
    return this.repository.getMonthDetailTransactions(params);
  }
}
